var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "studip-tree-child-description",
    },
    [
      _vm.isLoading
        ? _c("studip-loading-skeleton")
        : _c(
            "div",
            {
              directives: [
                {
                  name: "translate",
                  rawName: "v-translate",
                  value: {
                    count: _vm.courseCount,
                  },
                  expression: "{ count: courseCount }",
                },
              ],
              attrs: {
                "translate-n": _vm.courseCount,
                "translate-plural": "<strong>%{count}</strong> Veranstaltungen",
              },
            },
            [_c("strong", [_vm._v("Eine")]), _vm._v(" Veranstaltung\n    ")]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }